export const formatNumber = (value) => {
  // Handle undefined, null, or non-numeric values
  if (value === undefined || value === null || isNaN(Number(value))) {
    return "0";
  }

  const numValue = Number(value);

  if (numValue >= 1_000_000) {
    return (numValue / 1_000_000).toFixed(1) + "m";
  } else if (numValue >= 1_000) {
    return (numValue / 1_000).toFixed(1) + "k";
  } else {
    return numValue.toString();
  }
};

/**
 * Format reaction count for display with fire emoji
 * @param reactionCount The raw reaction count number
 * @returns Formatted string like "🔥 5.1k reactions"
 */
export const formatReactionCount = (reactionCount: number): string => {
  if (reactionCount === 0) {
    return "";
  }

  const formattedNumber = formatNumber(reactionCount);
  const plural = reactionCount === 1 ? "reaction" : "reactions";

  return `🔥 ${formattedNumber} ${plural}`;
};
